import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Row, Col } from "reactstrap"
import MetaTags from 'react-meta-tags';
import noImageFound from "./noImageFound.png"

const Pages404 = () => {
  return (
    <React.Fragment>
    
      <div className="authentication-bg d-flex align-items-center pb-0 mt-3">
        <div className="content-center w-100">
          <div className="container">
            <div className="row justify-content-center">
              <Col xl={10}>
                <Card style={{padding:"33px"}}>
                  <CardBody>
                    <div className="row align-items-center">
                      <div className="col-lg-4 ms-auto">
                        <div className="ex-page-content">
                          <h1 className="text-dark display-1 mt-4 font-weight-bold">Oops !!</h1>
                          <h2 className="mb-4">Sorry, no data found</h2>
                        </div>

                      </div>
                      <div className="col-lg-5 mx-auto img-fluid">
                       <img src={noImageFound}
                       className="img-fluid mx-auto d-block"

                       />
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Pages404
